import { Component, OnInit, OnDestroy, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { NgbModalRef, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { LayerPickerDialogService } from './layer-picker-dialog.service';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { LayersApiService } from 'src/app/model/api-services/layers-api.service';
import { SLLayer, LayerGeomtypes } from 'src/app/model/sl-layer';
import { InterruptableTimer } from 'src/app/model/interruptabletimer';
import { data } from 'jquery';

@Component({
  selector: 'app-layer-picker-dialog',
  templateUrl: './layer-picker-dialog.component.html',
  styleUrls: ['./layer-picker-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class LayerPickerDialogComponent implements OnInit {
  @HostBinding('class.layer-picker-dialog') cssId = true;
  @HostBinding('class.work-view') isWorkView = true;
  public hasItems = false;
  public items = [];
  private handler: AnyHandler;
  public sort = '';
  public sortDirection: boolean = true;
  public filter: string = '';
  public filterTimer: InterruptableTimer = new InterruptableTimer(700);
  public filteredItems: Array<SLLayer> = [];
  public loading = true;
  public get isAlphaSort(): boolean {
    return this.sort === 'name';
  }
  public get isAmountSort(): boolean {
    return (['name', ''].indexOf(this.sort) === -1);
  }

  public FilterItems() {
    this.filteredItems = this.items.filter((value: SLLayer, index: number) => {
      const lowerFilter = this.filter.toLowerCase();
      if (value.name.toLowerCase().indexOf(lowerFilter) !== -1) return true;
      if (value.data.last_modified.indexOf(lowerFilter) !== -1) return true;
      if (value.description.toLowerCase().indexOf(lowerFilter) !== -1) return true;
      if (value.tags.indexOf(lowerFilter) !== -1) return true;
      if (('' + value.id).indexOf(lowerFilter) !== -1) return true;
      return false;
    });
    if (this.sort !== '') {
      const prev = -1 * ((this.sortDirection) ? 1 : -1);
      const next = 1 * ((this.sortDirection) ? 1 : -1);
      switch (this.sort) {
        case 'name':
          this.filteredItems.sort((a: SLLayer, b: SLLayer): number => {
            return (a.name.toLowerCase() < b.name.toLowerCase()) ? prev : next;
          });
          break;
        case 'type':
          this.filteredItems.sort((a: SLLayer, b: SLLayer): number => {
            return (a.typeString.toLowerCase() < b.typeString.toLowerCase()) ? prev : next;
          });
          break;
        case 'date-modified':
          this.filteredItems.sort((a: SLLayer, b: SLLayer): number => {
            if (!a.data.date_modified) return 0;
            if (!b.data.date_modified) return 0;
            const startDate = new Date(a.data.date_modified + 'Z-800').valueOf();
            const endDate = new Date(a.data.date_modified + 'Z-800').valueOf();
            return startDate < endDate ? prev : next;
          });
          break;
        case 'layer-id':
          this.filteredItems.sort((a: SLLayer, b: SLLayer): number => {
            return (Number(a.id) < Number(b.id)) ? prev : next;
          });
          break;
      }
    }
  }
  private _ready = false;
  constructor(private cdr: ChangeDetectorRef, private activeModal: NgbActiveModal, private layersSvc: LayersApiService) { }

  ngOnInit() {
    this._ready = true;
  }
  Show(info) {
    this.filter = '';
    this.loading = true;
    this.items = [];
    this.Refresh();
    this.handler = info.handler;
    this.layersSvc.GetSrcLayers('mine').then((message) => {
      this.loading = false;
      this.Refresh();
      for (const item of message.response.results) {
        this.items.push(new SLLayer(item));
      }
      this.hasItems = this.items.length > 0;
      this.FilterChanged();
    });
  }
  GetName(item: SLLayer) {
    return item.name;
  }
  GetID(item: SLLayer) {
    return item.id;
  }
  GetIcon(item: SLLayer) {
    const geom = Number(item.geom);
    const icon = SLLayer.GetIconFromTypes(item.type, item.geom);
    return icon;
  }
  NotFontIcon(item: SLLayer) {
    return this.GetIcon(item) !== 'font-icon';
  }
  Cancel() {
    this.activeModal.close();
  }
  Select(item: SLLayer) {
    this.handler(item);
    delete this.handler;
    this.items = [];
    this.activeModal.close();
    this.Refresh();

  }
  FilterChanged() {
    this.filterTimer.Cancel();
    this.filterTimer.Start(() => {
      this.FilterItems();
      this.Refresh();
    });
  }
  ClearFilter() {
    this.filter = '';
    this.Refresh();
    this.FilterChanged();
    this.Refresh();
  }
  CopyId(id:string) {
    navigator?.clipboard?.writeText(id);
  }
  Refresh() {
    if (!this._ready) return;
    this.cdr.detectChanges();
  }

}

@Component({
  selector: 'app-layer-picker-dialog-entry',
  template: ''
})
export class LayerPickerDialogEntryComponent implements OnDestroy {
  modalRef: NgbModalRef;
  subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();
  lastTitle: string | null = null;

  constructor(private modalService: NgbModal, private service: LayerPickerDialogService) {
    this.subscriptionMgr.Subscribe(this.service.request$, (info: any) => {
      this.modalRef = this.modalService.open(LayerPickerDialogComponent, { backdrop: 'static' });
      (this.modalRef.componentInstance as LayerPickerDialogComponent).Show(info);
    });
  }
  ngOnDestroy(): void {
    this.subscriptionMgr.CancelSubscriptions();
  }

}
